import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';
import { updateSearch } from 'bernie-core';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { GexModule } from '@shared-ui/lodging-property-details';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from '../shared-ui/details//shared-ui-property-details';

const GexModuleWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => {
  const history = useHistory();
  const location = useLocation();

  const onClickReviews = React.useCallback(
    () => updateSearch({ history, location, newParams: { pwaDialog: 'reviews' } }),
    [history, location]
  );

  return (
    <ErrorBoundary label="hotel.property.gex-module">
      <Experiment name="MPD_Traveler_GEX_Score_Web">
        <ExperimentControl>{null}</ExperimentControl>
        <ExperimentVariant bucket={1}>
          <GexModule onClickReviews={onClickReviews} inputs={inputs} />
        </ExperimentVariant>
        <ExperimentVariant bucket={2}>
          <GexModule onClickReviews={onClickReviews} inputs={inputs} />
        </ExperimentVariant>
        <ExperimentVariant bucket={3}>
          <GexModule onClickReviews={onClickReviews} inputs={inputs} />
        </ExperimentVariant>
      </Experiment>
    </ErrorBoundary>
  );
};

export const SharedUiGexWrapper = withSharedUiPropertyDetails(GexModuleWrapper);
SharedUiGexWrapper.displayName = 'SharedUiGexWrapper';
